document.addEventListener("DOMContentLoaded", () => {
  const popup = document.getElementById("popup-overlay");
  const closeBtn = document.getElementById("popup-close");

  if (!popup) return;

  // Legge il delay dal markup (impostato dal Theme Editor)
  const delayAttr = popup.getAttribute("data-delay");
  const delay = delayAttr ? parseInt(delayAttr) : 2500;

  // Chiave per sessionStorage
  const popupKey = "popupShown";

  // Mostra solo una volta per sessione
  if (!sessionStorage.getItem(popupKey)) {
    setTimeout(() => {
      popup.style.display = "flex";
      sessionStorage.setItem(popupKey, "true");
    }, delay);
  }

  // Chiudi con X
  closeBtn?.addEventListener("click", () => {
    popup.style.display = "none";
  });

  // Chiudi cliccando fuori
  popup.addEventListener("click", (e) => {
    if (e.target === popup) popup.style.display = "none";
  });
});
